import { Diagnosis, useObservable, RemSize } from '@streem/sdk-react';
import { Theme } from '@streem/ui-react';
import { FC } from 'react';
import { useDetailSession } from '../../../hooks/detail_session_hooks';
import { convertProtobufToDiagnosisProps } from '../../../util/convert_room_outcome_protobuf';

// make changed
// this component is responsible for gathering the diagnosis data for a room
export const CallDetailDiagnosis: FC = () => {
    const detailSession = useDetailSession();
    const [roomOutcomeReport] = useObservable(detailSession.personalizations.roomOutcomeReport);

    const diagnosisProps = roomOutcomeReport?.roomOutcomeReport
        ? convertProtobufToDiagnosisProps(roomOutcomeReport.roomOutcomeReport)
        : undefined;
    if (!diagnosisProps) {
        return null;
    }

    const { diagnoses } = diagnosisProps;
    // If the following values are true or false, show checkboxes for them.  If they are undefined, do not show a checkbox.
    const showOutOfScopeDiscussionYn = typeof diagnosisProps?.outOfScopeDiscussionYn === 'boolean';
    const showRefundRequestYn = typeof diagnosisProps?.shouldRefundYn === 'boolean';
    const showScreenShare = typeof diagnosisProps?.screenShare === 'boolean';
    const showContractorCall = typeof diagnosisProps?.contractorCall === 'boolean';
    const showHvacMentioned = typeof diagnosisProps?.hvacMentioned === 'boolean';

    return (
        <CallDetailDiagnosisComponent
            diagnoses={diagnoses}
            disposition={diagnosisProps.disposition}
            outOfScopeDiscussionYn={diagnosisProps.outOfScopeDiscussionYn}
            outOfScopeDiscussionReasons={diagnosisProps.outOfScopeDiscussionReasons}
            refundRequest={diagnosisProps.shouldRefundYn}
            refundReason={diagnosisProps.refundReason}
            screenShare={diagnosisProps.screenShare}
            showScreenShare={showScreenShare}
            contractorCall={diagnosisProps.contractorCall}
            showContractorCall={showContractorCall}
            hvacMentioned={diagnosisProps.hvacMentioned}
            showHvacMentioned={showHvacMentioned}
            showOutOfScopeDiscussionYn={showOutOfScopeDiscussionYn}
            showRefundRequestYn={showRefundRequestYn}
        />
    );
};

interface CallDetailDiagnosisProps {
    diagnoses: string[];
    disposition: string;
    outOfScopeDiscussionYn?: boolean;
    outOfScopeDiscussionReasons?: string[];
    refundRequest?: boolean;
    refundReason?: string;
    screenShare?: boolean;
    showScreenShare: boolean;
    contractorCall?: boolean;
    showContractorCall: boolean;
    hvacMentioned?: boolean;
    showHvacMentioned: boolean;
    showOutOfScopeDiscussionYn: boolean;
    showRefundRequestYn: boolean;
}
// this component is responsible for rendering the diagnosis data for a room
const CallDetailDiagnosisComponent = ({
    diagnoses,
    disposition,
    outOfScopeDiscussionYn,
    outOfScopeDiscussionReasons,
    refundRequest,
    refundReason,
    screenShare,
    showScreenShare,
    contractorCall,
    showContractorCall,
    hvacMentioned,
    showHvacMentioned,
    showOutOfScopeDiscussionYn,
    showRefundRequestYn,
}: CallDetailDiagnosisProps) => {
    return (
        <Diagnosis
            diagnoses={diagnoses}
            disposition={disposition}
            outOfScopeDiscussion={outOfScopeDiscussionYn}
            outOfScopeDiscussionReasons={outOfScopeDiscussionReasons}
            refundRequest={refundRequest}
            refundReason={refundReason}
            screenShare={screenShare}
            showScreenShare={showScreenShare}
            contractorCall={contractorCall}
            showContractorCall={showContractorCall}
            hvacMentioned={hvacMentioned}
            showHvacMentioned={showHvacMentioned}
            showOutOfScopeDiscussionYn={showOutOfScopeDiscussionYn}
            showRefundRequestYn={showRefundRequestYn}
            dataIdPrefix="post-call-details"
            diagnosisStyles={{
                titleFontSize: Theme.text.size.notQuiteAllTheWayMediumLarge as RemSize,
            }}
            keyValueStyles={{ fontSize: Theme.text.size.medium as RemSize }}
        />
    );
};
